if (!Shopify.designMode) {
  function processUrl(url, addEnPrefix = false) {
    if (url.startsWith('/en/')) {
      url = url.replace('/en/', '/');
    } else if (url.startsWith('/en')) {
      url = url.replace('/en', '');
    }

    if (!url.startsWith('https://') && !url.startsWith('http://')) {
      url = url.startsWith('/') ? url : '/' + url;

      if (addEnPrefix) {
        url = '/en' + url;
      }
    }
    return url;
  }

    function initHomeBehavior() {
        document.querySelectorAll('.js-local-storage').forEach((link) => {
            link.addEventListener('click', function () {
                const href = link.getAttribute('href');
                if (href) {
                    localStorage.setItem('rocket_redirect_url', processUrl(href));
                }
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initHomeBehavior);
    } else {
        initHomeBehavior();
    }
}
